export const chainId = 5
export const rpcUrls = ['https://goerli.infura.io/v3/']

export default {
  chainId: '0x' + chainId.toString(16),
  chainName: 'Goerli test network',
  nativeCurrency: {
    name: 'ETH',
    symbol: 'eth',
    decimals: 18,
  },
  rpcUrls,
  blockExplorerUrls: ['https://goerli.etherscan.io'],
}
